// Actions
export const API_RESPONSE_SUCCESS = "API_RESPONSE_SUCCESS";
export const API_RESPONSE_ERROR = "API_RESPONSE_ERROR";
export const GET_ASSOCIATES = "GET_ASSOCIATES";
export const GET_SUMMARY_ASSOCIATES = "GET_SUMMARY_ASSOCIATES";
export const GET_ORDER_ASSOCIATES = "GET_ORDER_ASSOCIATES";
export const CREATE_ASSOCIATES = "CREATE_ASSOCIATES";
export const UPDATE_ASSOCIATES = "UPDATE_ASSOCIATES";
export const DELETE_ASSOCIATES = "DELETE_ASSOCIATES";
export const CHECK_CPF_CUSTOMER = "CHECK_CPF_CUSTOMER";
